export function isMac() {
    return (
        navigator &&
        navigator.appVersion &&
        navigator.appVersion.indexOf("Mac") > -1
    );
}
